"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AsyncSelectSingle = void 0;

var React = _interopRequireWildcard(require("react"));

var _Select = require("grommet/components/Select");

var _Icons = require("./Icons");

var _AsyncSelectProps = require("./AsyncSelectProps");

var _DefaultRenderOption = _interopRequireDefault(require("./DefaultRenderOption"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var identity = function identity(x) {
  return x;
};

var pipe = function pipe() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (x) {
    return fns.reduce(function (v, f) {
      return f(v);
    }, x);
  };
};

var AsyncSelectSingle = function AsyncSelectSingle(_ref) {
  var createNewOption = _ref.createNewOption,
      fetchOptions = _ref.fetchOptions,
      _ref$options = _ref.options,
      defaultOptions = _ref$options === void 0 ? [] : _ref$options,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      _ref$newOptionPrompt = _ref.newOptionPrompt,
      newOptionPrompt = _ref$newOptionPrompt === void 0 ? function (search) {
    return "Create new \"".concat(search, "\"");
  } : _ref$newOptionPrompt,
      _ref$showSelected = _ref.showSelected,
      showSelected = _ref$showSelected === void 0 ? true : _ref$showSelected,
      noResultsMessage = _ref.noResultsMessage,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      onChange = _ref.onChange,
      onOpen = _ref.onOpen,
      onClose = _ref.onClose,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? 'Select one' : _ref$placeholder,
      renderValue = _ref.renderValue,
      _ref$renderOption = _ref.renderOption,
      renderOption = _ref$renderOption === void 0 ? _DefaultRenderOption.default : _ref$renderOption,
      value = _ref.value,
      valueIcon = _ref.valueIcon;

  /* NOTE: This stores the results from search before any filtering */
  var _React$useState = React.useState(defaultOptions),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      results = _React$useState2[0],
      updateResults = _React$useState2[1];

  var _React$useState3 = React.useState(noResultsMessage ? '' : undefined),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      emptySearchMessage = _React$useState4[0],
      setEmptySearchMessage = _React$useState4[1];
  /* Searching */


  var searchFn = function searchFn(rawSearch) {
    var search = rawSearch.trim();
    var searchableLength = search.length > 2;

    if (noResultsMessage) {
      // Enable noResultsMessage when search term is at least 3 chars
      setEmptySearchMessage(searchableLength ? noResultsMessage : '');
    } // Ignore search term until at least 3 chars


    if (!searchableLength) return Promise.resolve(defaultOptions);
    return fetchOptions(search).then(function (result) {
      if (!createNewOption) return result;
      var newOption = {
        value: search,
        label: newOptionPrompt(search),
        isNew: true
      };
      var matched = result.reduce(function (match, _ref2) {
        var label = _ref2.label;
        return match || label.toLowerCase() === search.toLowerCase();
      }, false);
      return search && !matched ? [newOption].concat(_toConsumableArray(result)) : result;
    });
  };

  var onSearch = function onSearch(search) {
    return searchFn(search).then(function (res) {
      return updateResults(res);
    });
  };
  /* Handle Changes */


  var handleChange = function handleChange(e) {
    if (createNewOption && e.option && e.option.isNew) {
      var newValue = e.option.value.trim();
      createNewOption(newValue).then(function (created) {
        onChange(created);
        /*
         * Need to trigger an new search after creating...
         * 1) remove the create new option (see that it exists already in "results")
         * 2) show the newly created option in the list (if showSelected=true)
         */

        onSearch(newValue);
      });
    } else {
      onChange(e.value);
    }

    if (noResultsMessage) {
      setEmptySearchMessage('');
    }
  };
  /* Options Rendering */


  var removeSelected = function removeSelected(options) {
    if (!value || !value.value) return options;
    return options.filter(function (s) {
      return s.value !== value.value;
    });
  };

  var options = pipe(showSelected ? identity : removeSelected)(results);
  /* If loading, don't render pills so placeholder is visible */

  var renderValueFn = valueIcon ? (0, _AsyncSelectProps.renderValueWithIcon)(valueIcon) : renderValue;
  var valueLabel = renderValueFn && renderValueFn(value, handleChange, disabled) || undefined;
  var placeholderLabel = valueIcon ? (0, _AsyncSelectProps.renderPlaceholderWithIcon)(valueIcon)(placeholder) : placeholder;
  /* Store open state to render correct icon */

  var _React$useState5 = React.useState(false),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      open = _React$useState6[0],
      setOpen = _React$useState6[1];

  var handleOpen = function handleOpen() {
    // Clear out the 'no search results' message until search term entered
    if (noResultsMessage) setEmptySearchMessage('');
    setOpen(true);
    if (onOpen) onOpen();
  };

  var handleClose = function handleClose() {
    setOpen(false);
    updateResults(defaultOptions);
    if (onClose) onClose();
  };

  return React.createElement(_Select.Select, {
    closeOnChange: true,
    placeholder: loading ? 'Loading...' : placeholderLabel,
    disabled: disabled || loading,
    onSearch: onSearch,
    value: !loading && value ? value : '',
    onChange: handleChange,
    options: options,
    valueLabel: valueLabel,
    labelKey: "label",
    valueKey: "value",
    onOpen: handleOpen,
    onClose: handleClose,
    icon: open ? React.createElement(_Icons.ArrowUpIcon, null) : React.createElement(_Icons.ArrowDownIcon, null),
    emptySearchMessage: emptySearchMessage
  }, renderOption);
};

exports.AsyncSelectSingle = AsyncSelectSingle;